// @flow
import type {Action} from '../../../state/types'

export type SignInPayload = {
  username: string,
  password: string,
}

const id = 'session/SIGN_IN'

export const signIn = (username: string, password: string): Action<SignInPayload> => ({
  type: id,
  payload: {
    username,
    password,
  }
})

signIn.id = id
